module.exports = __webpack_public_path__ + "h5/img/ckxkz@2x.33544fda.png";